import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message } from '@/components';
import { RootStore } from '@/models';
import * as API from '@/api';
import styles from './index.less';
import classNames from 'classnames';
import ActionBtn from '../ActionBtn';
import { useOpenAudio } from '@/pages/Meeting/hooks/useOpenAudio';

interface Props extends Partial<Pick<RootStore, 'rtc' | 'user'>> {
  RTCInstance?: RootStore['rtc'];
  user?: RootStore['user'];
}
const MicrophoneBtn: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    user: store.user,
  };
})(
  observer((props) => {
    const { RTCInstance, user } = props;
    const { formatMessage } = useIntl();

    const { openAudio } = useOpenAudio();

    return (
      <ActionBtn
        bottomTitle={
          RTCInstance?.micIsNotAvailable
            ? formatMessage({ id: 'MICROPHONE' })
            : RTCInstance?.isOpenAudio
            ? formatMessage({ id: 'MIC_OFF' })
            : formatMessage({ id: 'MIC_ON' })
        }
        className={classNames(styles['micBtn'], {
          [styles.on]: RTCInstance?.isOpenAudio,
          [styles.disable]: RTCInstance?.breakLineReconnecting || true,
        })}
        onClick={openAudio}
      >
        {RTCInstance?.isOpenAudio && (
          <Icon className={styles.icon} name="icon-micro_solid" mode="symbol" />
        )}
        {RTCInstance?.micIsNotAvailable && (
          <>
            <Icon className={styles.warn} name="icon-warming_solid" mode="symbol" />
            <Icon className={styles['not-available']} name="icon-micro_noequipment" />
          </>
        )}
        {!RTCInstance?.isOpenAudio && !RTCInstance?.micIsNotAvailable && (
          <Icon className={styles.icon} name="icon-micro_off_solid" mode="symbol" />
        )}
      </ActionBtn>
    );
  })
);

export default MicrophoneBtn;
